if (!customElements.get("td-uvp-drawer")) {
  class TdUvpDrawer extends HTMLElement {
    constructor() {
      super();
      this.body = document.querySelector("body");
      this.overlayClass = "td-uvpd__overlay";
      this.activeClass = "td-uvpd__content-wrapper--active";
    }

    connectedCallback() {
      this.initUvpDrawer();
    }

    initUvpDrawer() {
      const closeButtons = this.querySelectorAll(".td-uvpd__close");

      closeButtons.forEach((closeButton) => {
        closeButton.addEventListener("click", (event) => {
          const contentWrapper = closeButton.closest(".td-uvpd__content-wrapper");
          if (contentWrapper) {
            this.closeDrawer(contentWrapper);
          }
          event.stopPropagation();
        });
      });

      if (this.body) {
        this.body.addEventListener("click", (event) => {
          if (event.target === this.body && this.body.classList.contains(this.overlayClass)) {
            const contentWrapper = this.querySelector(`.${this.activeClass}`);
            if (contentWrapper) {
              this.closeDrawer(contentWrapper);
            }
          }
        });
      }

      this.bindDelegatedTrigger();
    }

    bindDelegatedTrigger() {
      if (document.__tdUvpDrawerTriggerDelegation) return;
      document.__tdUvpDrawerTriggerDelegation = true;

      document.addEventListener("click", (event) => {
        const trigger = event.target.closest("[data-trigger-uvp-drawer]");
        if (!trigger) return;

        const drawerInstance = trigger.getAttribute("data-uvp-drawer-instance");
        if (!drawerInstance) return;

        const drawer = document.querySelector(
          `td-uvp-drawer[data-uvp-drawer-instance="${drawerInstance}"]`
        );
        if (!drawer) return;

        const shouldOpenReviewApp = trigger.getAttribute("data-trigger-review-app") === "true";
        if (shouldOpenReviewApp) {
          event.preventDefault();
          drawer.closeAllDrawers();
          drawer.openReviewApp(drawerInstance);
          return;
        }

        const drawerNumber = trigger.getAttribute("data-trigger-uvp-drawer");
        const contentWrapper = drawer.querySelector(
          `[data-uvp-drawer-${drawerNumber}-wrapper]`
        );

        if (contentWrapper) {
          event.preventDefault();
          drawer.openDrawer(contentWrapper);
        }
      });
    }

    openDrawer(contentWrapper) {
      const hasActiveDrawer = Boolean(this.querySelector(`.${this.activeClass}`));

      this.querySelectorAll(`.${this.activeClass}`).forEach((openWrapper) => {
        if (openWrapper !== contentWrapper) {
          openWrapper.classList.remove(this.activeClass);
        }
      });

      if (this.body) {
        this.body.classList.add(this.overlayClass);
        if (!hasActiveDrawer) {
          this.lockBodyScroll();
        }
      }

      contentWrapper.classList.add(this.activeClass);
    }

    closeDrawer(contentWrapper) {
      contentWrapper.classList.remove(this.activeClass);

      if (!this.querySelector(`.${this.activeClass}`) && this.body) {
        this.body.classList.remove(this.overlayClass);
        this.unlockBodyScroll();
      }
    }

    closeAllDrawers() {
      const hadActiveDrawer = Boolean(this.querySelector(`.${this.activeClass}`));

      this.querySelectorAll(`.${this.activeClass}`).forEach((openWrapper) => {
        openWrapper.classList.remove(this.activeClass);
      });

      if (this.body) {
        this.body.classList.remove(this.overlayClass);
        if (hadActiveDrawer) {
          this.unlockBodyScroll();
        }
      }
    }

    openReviewApp(drawerInstance) {
      if (window.TdJudgeMeTrigger && window.TdJudgeMeTrigger.openFloatingTab()) return;

      const proxy = document.querySelector(`[data-uvp-review-proxy="${drawerInstance}"]`);

      if (proxy) {
        const proxyTargets = [
          ".jdgm-prev-badge__stars",
          ".jdgm-prev-badge__text",
          ".jdgm-prev-badge",
          'a[href="#judgeme_product_reviews"]',
        ];

        for (const selector of proxyTargets) {
          const target = proxy.querySelector(selector);
          if (target) { target.click(); return; }
        }

        proxy.click();
      }
    }

    lockBodyScroll() {
      if (!this.body) return;
      if (!window.TdBodyScrollLock || typeof window.TdBodyScrollLock.lock !== "function") return;
      window.TdBodyScrollLock.lock(this.body);
    }

    unlockBodyScroll() {
      if (!this.body) return;
      if (!window.TdBodyScrollLock || typeof window.TdBodyScrollLock.unlock !== "function") return;
      window.TdBodyScrollLock.unlock(this.body);
    }
  }

  customElements.define("td-uvp-drawer", TdUvpDrawer);
}
